module.exports = __webpack_public_path__ + "static/media/node-1.cbfe8ebe.svg";